﻿import {translation} from "@2d-front-monorepo/core";
import {FC, memo} from "react";
import {parkingPrebookingAvailabilityTypeLabel, parkingPrebookingAvailabilityTypeName} from "../helpers/enumNaming";
import {ParkingPrebookingAvailabilityType} from "../index";

interface PrebookingAvailabilityTypeProps {
	type: ParkingPrebookingAvailabilityType;
}

export const PrebookingAvailabilityTypeComponent: FC<PrebookingAvailabilityTypeProps> = memo(({type}) => {
		const pillClass = `pill__availability-type--${parkingPrebookingAvailabilityTypeName(type)}`;
		const label = translation(parkingPrebookingAvailabilityTypeLabel(type));
		return <span className={`pill ${pillClass} pill--small`}>{label}</span>;
	}
)
